import SectionLabel from "../common/SectionLabel";
import ContributionGraph from "./ContributionGraph";

function GithubActivity() {
  return (
    <section id="activity" className="divider">
      <div className="wrap">
        <SectionLabel label="github activity" />

        <ContributionGraph />
      </div>
    </section>
  );
}

export default GithubActivity;
